import React from 'react';
import { ArrowLeft, User, Clock, Eye, Coins } from '@phosphor-icons/react';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * Full-screen VOD replay viewer. Purely presentational.
 */
const ReplayViewer = ({ replay, onBack, replayVideoRef }) => {
  if (!replay) return null;
  return (
    <div className="max-w-5xl mx-auto px-4 py-6" data-testid="replay-viewer">
      <button
        onClick={onBack}
        className="text-slate-400 hover:text-white mb-4 text-sm flex items-center gap-1"
      >
        <ArrowLeft className="w-4 h-4" /> Back to streams
      </button>
      <div className="glass-light rounded-2xl overflow-hidden">
        <div className="aspect-video bg-black">
          <video
            ref={replayVideoRef}
            src={`${API}${replay.media_url}`}
            controls
            autoPlay
            playsInline
            className="w-full h-full"
            data-testid="replay-video"
          />
        </div>
        <div className="p-5">
          <h2 className="font-heading text-xl font-bold text-white">{replay.title}</h2>
          <div className="flex items-center gap-4 mt-2 text-sm text-slate-400">
            <span className="flex items-center gap-1"><User className="w-4 h-4" /> {replay.creator_name}</span>
            {replay.duration_seconds > 0 && (
              <span className="flex items-center gap-1">
                <Clock className="w-4 h-4" /> {Math.floor(replay.duration_seconds / 60)}m {Math.round(replay.duration_seconds % 60)}s
              </span>
            )}
            <span className="flex items-center gap-1"><Eye className="w-4 h-4" /> {replay.views_count} views</span>
            {replay.tokens_received > 0 && (
              <span className="flex items-center gap-1"><Coins weight="fill" className="w-4 h-4 text-amber-400" /> {replay.tokens_received} earned</span>
            )}
          </div>
          {replay.description && <p className="text-slate-500 mt-3 text-sm">{replay.description}</p>}
        </div>
      </div>
    </div>
  );
};

export default ReplayViewer;
